export default class ObjectUtil {
    public static ObjectToArray(theObject: object): { key: string, value: object }[] {
        return Object.keys(theObject).map(x => {
            return {
                key: x,
                value: theObject[x]
            } as { key: string, value: object };
        });
    }

    // public static ObjectToArrayDeep(theObject: object): { key: string, value: object }[] {
    //     if (theObject == null) {
    //         return theObject;
    //     }
    //     return Object.keys(theObject).map(x => {
    //         return {
    //             key: x,
    //             value: theObject[x]
    //         } as { key: string, value: object };
    //     });
    // }

    public static DiagnosticInfo(obj: any): void {
        let output = "";

        let objType = typeof obj;
        let keys = Object.keys(obj);
        let isArray = Array.isArray(obj);
        let isNumber = Number.isInteger(obj);
        let hasSubMembers = keys.some(x => x != null && typeof (x) === 'object' && !Array.isArray(x));

        output =
            `## Object Diagnostic Info ##` + "\n" +
            `Type: ${objType}` + "\n" +
            `IsNumber: ${isNumber}` + "\n" +
            `IsArray: ${isArray}` + "\n" +
            `HasSubMembers: ${hasSubMembers}` + "\n" +
            `Keys: \n${keys.map(x => ` ${x}: ${typeof obj[x]}`).join("\n")}`;

        // output = output.split(" ").filter(x => x).join(" ");

        console.warn(output); // JB - Remove this console.warn
    }

    /**
     * Applies a second object onto the first, traversing the sub-objects to do the same.
     *
     * @param {T} left The source object. These params are overwritten if they exist in both.
     * @param {T} right The params from this object overwrite the params in the first object.
     * @param {boolean} [arrayRule=false] Indicates if arrays should be appended to one another. Default is to merge each array item based on index.
     */
    public static DeepMergeObjects<T>(left: T, right: T, arrayRule: "default" | "take-left" | "take-right" | "concat" | "merge-index" = "default"): T {
        let obj = { ...(left || {}), ...(right || {}) } as T;
        let keys = Object.keys(obj);
        keys.forEach(key => {
            let innerObj = obj[key];
            let isArray = Array.isArray(innerObj);
            let isObject = typeof (innerObj) === 'object';

            if (innerObj != null && isObject && !isArray) {
                let first = left == null ? { [key]: null } : left;
                let second = right == null ? { [key]: null } : right;

                // Recurse and put result back into merged object
                obj[key] = this.DeepMergeObjects(first[key], second[key], arrayRule);
            } else if (isArray) {
                let arrayResult = [];
                let safeLeft: Array<any> = (left || { [key]: [] })[key] || [];
                let safeRight: Array<any> = (right || { [key]: [] })[key] || [];

                switch (arrayRule) {
                    case "take-left":
                        arrayResult = safeLeft;
                        break;
                    case "take-right":
                        arrayResult = safeRight;
                        break;
                    case "concat":
                        arrayResult = [...safeLeft, ...safeRight];
                        break;
                    case "default":
                    case "merge-index":
                        let minLength = Math.min(safeLeft.length, safeRight.length);
                        let maxLength = Math.max(safeLeft.length, safeRight.length);

                        for (let index = 0; index < minLength; index++) {
                            // Account for nulls, then account for non objects
                            if (safeLeft == null || safeRight == null) {
                                // Nothing to calculate, just return whatever is not null, or null, starting with the right
                                arrayResult.push(safeRight[index] || safeLeft[index]);
                            }
                            if (typeof safeLeft[index] !== 'object' || typeof safeRight[index] !== 'object') {
                                // One or both are primitives of some kind. Pick left if it's an object, else default to right
                                // Also, errors should only show when we are choosing this on purpose
                                arrayRule === "merge-index" && console.warn("Type error when merging array objects. Defaulting to rightmost object", safeLeft[index], safeRight[index]);
                                if (typeof safeLeft[index] === 'object') {
                                    arrayResult.push(safeLeft[index]);
                                } else {
                                    arrayResult.push(safeRight[index]);
                                }
                                continue;
                            }
                            arrayResult.push(this.DeepMergeObjects(safeLeft[index], safeRight[index], arrayRule));
                        }

                        if (minLength !== maxLength) {
                            // Add extras that have no match
                            let arr = safeLeft.length > minLength ? safeLeft : safeRight;
                            for (let index = minLength; index < maxLength; index++) {
                                arrayResult.push(arr[index]);
                            }
                        }

                        break;
                    default:
                    arrayResult = [];
                }

                // Put result back into merged object
                obj[key] = arrayResult;
            }
        });

        return obj;
    }
}



// WEBPACK FOOTER //
// ./src/utils/ObjectUtil.ts